import { render, staticRenderFns } from "./TournamentRound.vue?vue&type=template&id=55c09a11&scoped=true"
import script from "./TournamentRound.vue?vue&type=script&lang=js"
export * from "./TournamentRound.vue?vue&type=script&lang=js"
import style0 from "./TournamentRound.vue?vue&type=style&index=0&id=55c09a11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c09a11",
  null
  
)

export default component.exports